import React from 'react';

import Button from '@atlaskit/button/default/button';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { FormattedMessage } from 'react-intl';

import { useAnalytics } from '@townsquare/analytics';
import { useRovoWorkspace } from '@townsquare/collab-context';
import { useHRISConnectors } from '@townsquare/teams-hris/store';
import { useAdminHubLinkForSite } from '@townsquare/url-utils';

export const HRISActionButton = (): React.JSX.Element | null => {
	const analytics = useAnalytics();
	const siteId = useRovoWorkspace();
	const adminHubUrlForSite = useAdminHubLinkForSite(siteId ?? undefined);
	const [{ activeConnector }] = useHRISConnectors();
	const handleAdminHubLinkClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		analytics.ui('teamsHrisConnectorAdminHubRedirect', 'clicked', {
			redirectFrom: 'settingsHeader',
		});
		open(
			`${adminHubUrlForSite}/user-connected-apps/tab/installed?teamsConnectorRedirect=true`,
			'_blank',
			'noreferrer',
		);
	};

	return (
		activeConnector && (
			<Button iconAfter={LinkExternalIcon} onClick={handleAdminHubLinkClick}>
				<FormattedMessage
					id="townsquare.teams-settings.header.connect-tool-button"
					defaultMessage="Connect tool"
					description="Button to connect a tool in admin hub"
				/>
			</Button>
		)
	);
};
